import { memo, useCallback, useEffect, useState } from 'react';
import { useResponsive } from 'app/hooks';
import { useFiles } from '../../hooks/use-files';
import {
  Dialog,
  MediaItem,
  message,
  VStack,
} from 'app/pages/request-single-page/components-v4';
import { useV4Theme } from 'app/pages/request-single-page/components-v4/theme';
import { DialogHeader, DialogBody, SuccessBody, DialogFooter } from './ui';

type FilesDraftDialogProps = {
  open: boolean;
  committedFilesLenght: number;
  draftFiles: MediaItem[];
  uploadStatus: ReturnType<typeof useFiles>['uploadStatus'];
  onDraftChange: (files: MediaItem[]) => void;
  onCommit: ReturnType<typeof useFiles>['handleCommit'];
  onDiscard: ReturnType<typeof useFiles>['handleDiscard'];
};

export const FilesDraftDialog = memo(
  ({
    open,
    committedFilesLenght,
    draftFiles,
    onDraftChange,
    onCommit,
    uploadStatus,
    onDiscard,
  }: FilesDraftDialogProps) => {
    const theme = useV4Theme();
    const { viewport } = useResponsive();
    const [showSuccess, setShowSuccess] = useState<boolean>(false);

    useEffect(() => {
      if (!open) {
        setShowSuccess(false);
      }
    }, [open]);

    const handleCommit = useCallback(async () => {
      try {
        await onCommit();
        setShowSuccess(true);
      } catch (error) {
        message({ type: 'error', text: 'Не удалось загрузить файлы' });
      }
    }, [onCommit]);

    return (
      <Dialog.Root open={open} onOpenChange={onDiscard}>
        <Dialog.Portal>
          <Dialog.Content
            style={{
              width: viewport.desktop ? '650px' : '100dvw',
              alignItems: 'center',
              minHeight: viewport.desktop ? 'fit-content' : '100dvh',
            }}
          >
            <Dialog.Panel
              style={{
                position: 'relative',
                width: '100%',
                height: '100%',
              }}
            >
              <VStack flex={1} padding={theme.spacings.base}>
                <DialogHeader onClose={onDiscard} />

                {showSuccess ? (
                  <SuccessBody onCancel={onDiscard} />
                ) : (
                  <>
                    <VStack flex={1}>
                      <DialogBody
                        committedFilesLength={committedFilesLenght}
                        draftFiles={draftFiles}
                        onDraftChange={onDraftChange}
                      />
                    </VStack>

                    <DialogFooter
                      hasFiles={!!draftFiles.length}
                      uploadStatus={uploadStatus}
                      onCancel={onDiscard}
                      onCommit={handleCommit}
                    />
                  </>
                )}
              </VStack>
            </Dialog.Panel>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    );
  }
);
